import React from 'react';
import { useTranslation } from 'react-i18next';
import { ErrorRetry } from '../ui/ErrorRetry';

interface Props {
  message?: string;
  onRetry: () => void;
}

export const ErrorBookings: React.FC<Props> = ({ message, onRetry }) => {
  const { t } = useTranslation('customer');
  return (
    <ErrorRetry
      message={message ?? t('bookings.error.defaultMessage')}
      onRetry={onRetry}
    />
  );
};
